// extracted by mini-css-extract-plugin
export var infoRow = "_s6-2";
export var labelContainer = "_s6-0";
export var rightInfo = "_s6-1";